import { Box, MenuItem, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import TradeModal from 'src/components/activity-modals/trades-model';
import DropDownAddValueWrapper from 'src/components/drop-down-add-value/drop-down-add-value-wrapper';
import { RHFSelect } from 'src/components/hook-form';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

export default function ActivityAssigntaskRow() {
  const [trades, setTrades] = useState([]);

  const getTrades = async () => {
    try {
      const data = await getRequest(endpoints.ganttChart.get_trades_list);
      setTrades(data);
    } catch (error) {
      console.error('Error fetching trade data: ', error);
    }
  };

  useEffect(() => {
    getTrades();
  }, []);

  return (
    <>
      <Box>
        <Typography variant="h6" sx={{ pb: 2, pt: 2 }} className="heading1">
          Assign Task
        </Typography>
        <Box
          mt={2}
          mb={2}
          gap={3}
          display="grid"
          gridTemplateColumns={{
            xs: 'repeat(2, 1fr)',
            lg: 'repeat(4, 1fr)',
          }}
        >
          <DropDownAddValueWrapper
            name="trade"
            label="Select Trade"
            options={trades}
            url={endpoints.ganttChart.add_trade}
            reload={() => getTrades()}
            InstantCreateComponent={TradeModal}
          />

          <RHFSelect name="assign_scope_to_subcontractors?" label="Assign Scope To Subcontractors?">
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </RHFSelect>
        </Box>
      </Box>
    </>
  );
}
